import { render, staticRenderFns } from "./GroupAncestorOverview.vue?vue&type=template&id=7567ca0a&scoped=true&"
import script from "./GroupAncestorOverview.vue?vue&type=script&lang=js&"
export * from "./GroupAncestorOverview.vue?vue&type=script&lang=js&"
import style0 from "./GroupAncestorOverview.vue?vue&type=style&index=0&id=7567ca0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7567ca0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
